import { Box, makeStyles, Typography } from "@material-ui/core";
import { SvgImage } from "../../../images/svg";
import React from "react";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "19px",
    fontWeight: 500,
    color: "#114668",
    textAlign: "center",
  },
  titleDisabled: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "19px",
    fontWeight: 500,
    color: "#8ba5b5",
    textAlign: "center",
  },
  description: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "16px",
    fontWeight: 300,
    color: "#bcbcbc",
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: 160,
    width: 160,
    backgroundColor: "#fff",
    border: "3px solid #efeff2",
    margin: 10,
    borderRadius: 10,
  },
}));

const SectionButton = ({ title, description, image, onClick, disabled }) => {
  const classes = useStyles();

  return (
    <Box className={classes.box} onClick={disabled ? () => {} : onClick}>
      <SvgImage type={image} />
      <Typography className={disabled ? classes.titleDisabled : classes.title}>
        {title}
      </Typography>
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
    </Box>
  );
};

export default SectionButton;
